import CatalogTableReport from './CatalogTableReport';
import { BILLCOM_AP_WRITEBACK_STATUS } from '../../consts/reports';

const BillcomApWritebackStatusReport = (props) => (
    <CatalogTableReport
        {...props}
        reportType={BILLCOM_AP_WRITEBACK_STATUS}
        title="Bill.com AP Writeback Status"
        description="Review Bill.com AP writeback claims against independently verified Eadin ledger state."
        includeStaleHours
        defaultDays={90}
    />
);

export default BillcomApWritebackStatusReport;
